import React, { useEffect, useState } from 'react'
import * as helper from '../global/helper';

const AddContactModal = (props) => {

    const [contact,             setContact]             = useState({});

    useEffect(() => {
        $('#contact-modal').modal({ backdrop: 'static' });

        $('#contact-modal').on('hidden.bs.modal', function () {
            props.onDismissModal(); 
        });

        $('#contact-modal').modal('toggle');
    }, [props.show]);

    const updateContactDetails = (field, value) => {   
        setContact((d) => {
            return { ...d, [field]: value };
        });
    };

    const AddContactHandler = async (e) => {
        e.preventDefault()
        const btn = $('#btnContactSave');
        var form = $('#add-contact-form');

        form.validate({
            rules: {
                txtMobile: {
                    required: true,
                    number: true,
                    minlength: 10,
                    maxlength: 10,
                },
                txtContactName: {
                    required: true
                }, 
            },
            messages: {
                txtMobile: {
                    required: "Please enter mobile",
                },
                txtContactName: {
                    required: "Please enter name",
                },
            }
        });

        if (!form.valid()) return;

        try {
            props.setContactList(c => ([...c, contact]))
            $("#contact-modal").modal("hide");
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    return (
        <div className="modal fade" id="contact-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Add Contact </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"> </button>
                    </div>
                    <form className='' id='add-contact-form'>
                        <div className="modal-body">
                            <div className="modal-body padding-25 padding-b0">
                                <div id="contact-modal-holder" className="kt-form kt-form--label-right padding-10" role="form">
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Contact Name <span className="red">*</span></label>
                                            <div className="col-xl-6 col-lg-8">
                                                <input id="txtContactName" name="txtContactName" 
                                                    value={contact.ContactPersonName || ''}
                                                    onChange={(event) => updateContactDetails('ContactPersonName', event.target.value)}
                                                    type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Contact Mobile<span className="red">*</span> </label>
                                            <div className="col-xl-6 col-lg-8">
                                                <input id="txtMobile" name="txtMobile" 
                                                    value={contact.ContactPersonMobile || ''}
                                                    onChange={(event) => updateContactDetails('ContactPersonMobile', event.target.value)}
                                                    type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Contact Email</label>
                                            <div className="col-xl-6 col-lg-8">
                                                <input id="txtContactEmail" name="txtContactEmail" 
                                                    value={contact.ContactPersonEmail || ''}
                                                    onChange={(event) => updateContactDetails('ContactPersonEmail', event.target.value)}
                                                    type="text" className="form-control" />
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div className="modal-footer padding-tb10">
                                <button type="button" data-dismiss="modal" className="btn btn-secondary margin-0 margin-r5 " id="btn_close">Close </button>
                                <button type="button" className="btn btn-brand margin-0 " id="btnContactSave" onClick={AddContactHandler}>Add </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddContactModal